import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-register',

  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent {

}
